import {Fragment, useContext, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import CompanyTabs from "#src/components/companyTabs.js";
import { IoIosArrowRoundForward } from "react-icons/io";
import integrations from '#src/configs/config.json';


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


export const CompanyIntegrations = () => {


    return (


            <div className="mx-auto max-w-7xl w-full bg-gray-100 px-4">
                <h2 className="text-xl my-8 flex  font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                    Account
                </h2>
                <CompanyTabs page={"Integrationen"}/>
                <div className=" mb-12 w-full  gap-x-8">
                    <div className="isolate mx-auto mt-16 grid gap-4 max-w-md grid-cols-1 gap-y-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-4">
                        {integrations?.integrations.map((product) => (
                            <a href={"/company/integrations/"+product.id}  key={product.id} className="group block border-gray-400 border rounded-lg relative">
                                <img
                                    src={`${process.env.PUBLIC_URL}/integrations/${product.logo}`}
                                    className="aspect-square w-full p-12 pt-8 pb-0 m-auto  rounded-lg bg-white object-contain bg-center group-hover:opacity-75  h-[90px] "
                                />
                                <div className="mt-4 p-4 flex justify-between">
                                    <div>
                                        <h3 className="text-sm font-bold text-gray-900">
                                            <a href={"/company/integrations/"+product.id}>
                                                {product.name}
                                            </a>
                                        </h3>
                                        <p className="mt-2 text-sm min-h-[150px] text-gray-600/60">{product.descriptionsShort}</p>
                                        <div className={"mt-2 inline-block text-xs bg-indigo-900 px-2 py-1 rounded "}>{product.type}</div>
                                    </div>

                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
    )
}
